import { render, staticRenderFns } from "./CustomerRow.vue?vue&type=template&id=1d337ad6&scoped=true&"
import script from "./CustomerRow.vue?vue&type=script&lang=ts&"
export * from "./CustomerRow.vue?vue&type=script&lang=ts&"
import style0 from "./CustomerRow.vue?vue&type=style&index=0&id=1d337ad6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d337ad6",
  null
  
)

export default component.exports